export const SHORTCUT_TEXT_MATERIAL_CATEGORY_FIELDS = `
  id
  created_at
  updated_at
  name
  title
  slug
  status
  parent {
    id
    created_at
    updated_at
    name
  }
  activeFrom
  activeUntil
  priority_weight
  i18n {
    languageCode
    title
  }
`

export const SHORTCUT_TEXT_MATERIAL_TYPES_FIELDS = `
  id
  name
  title
  i18n {
    languageCode
    title
  }
  created_at
  updated_at
  icon
`


export const SHORTCUT_TEXT_MATERIAL_THEME_FIELDS = `
  id
  name
  slug
  title
  status
  activeFrom
  activeUntil
  priority_weight
  i18n {
    languageCode
    title
  }
  created_at
  updated_at
`

export const SHORTCUT_TEXT_MATERIAL_TAG_FIELDS = `
  id
  name
  slug
  title
  created_at
  updated_at
`

export const SHORTCUT_TEXT_MATERIAL_FIELDS = `
  id
  name
  type {${SHORTCUT_TEXT_MATERIAL_TYPES_FIELDS}}
  category {${SHORTCUT_TEXT_MATERIAL_CATEGORY_FIELDS}}
  themes {${SHORTCUT_TEXT_MATERIAL_THEME_FIELDS}}
  tags {${SHORTCUT_TEXT_MATERIAL_TAG_FIELDS}}
  preview {
    url
  }
  defaultLanguage
  preview_source
  preview_url
  slug
  status
  created_at
  updated_at
  publishedAt
  activeFrom
  activeUntil
  isPublished
  isActive
  viewsCount
  likesCount
  commentsCount
  averageRating
  title
  content
  i18n {
    languageCode
    title
    content
    lead
  }

  priority_weight
`